import type { BasicCustomMailOptionalItemOverrideInput, LangCode } from "@/lib/gql/__generated__/graphql";

import { FeatureIslandCategoryQuestionForMain } from "@/components/features/_layouts/island/main-with-category/components/category-main-question";
import type { ForAutoGenerator } from "@/components/features/_model/types/auto-generator-for-view-model";

import { QuestionEmailTemplateItem } from "../_shared/components/email-template-item";

import type { ProductPlanI18nFormModel } from "../../../../../../model";

type Props = {
	isEdited: boolean;
	hasError: boolean;
	// チェックイン7日前
	atCheckInBefore_07days: ForAutoGenerator<BasicCustomMailOptionalItemOverrideInput, "">;
	onSetAtCheckInBefore_07daysForText: (value: string) => void;
	handleClickedSendTestEmailReservationAtCheckInBefore_07days: ({
		lang,
		email,
	}: {
		lang: LangCode;
		email: string;
	}) => Promise<void>;
	// チェックイン1日前
	atCheckInBefore_01days: ForAutoGenerator<BasicCustomMailOptionalItemOverrideInput, "">;
	onSetAtCheckInBefore_01daysForText: (value: string) => void;
	handleClickedSendTestEmailReservationAtCheckInBefore_01days: ({
		lang,
		email,
	}: {
		lang: LangCode;
		email: string;
	}) => Promise<void>;
	// チェックイン当日
	atCheckInBefore_00days: ForAutoGenerator<BasicCustomMailOptionalItemOverrideInput, "">;
	onSetAtCheckInBefore_00daysForText: (value: string) => void;
	lang: LangCode;
	handleClickedSendTestEmailReservationAtCheckInBefore_00days: ({
		lang,
		email,
	}: {
		lang: LangCode;
		email: string;
	}) => Promise<void>;
	hotelEmailAddress: string;
	title?: string;
	guide?: string;

	/** 基本メール設定の文言 */
	basicCustomMailSetting: ProductPlanI18nFormModel["QueryData"]["basicCustomMailSetting"];
	/** デフォルトプランメール設定 */
	defaultPlanCustomMailSetting: ProductPlanI18nFormModel["QueryData"]["defaultPlanCustomMailSetting"];
};

export const ForCheckInEmailTemplates = ({
	isEdited,
	hasError,
	// チェックイン7日前
	atCheckInBefore_07days,
	onSetAtCheckInBefore_07daysForText,
	handleClickedSendTestEmailReservationAtCheckInBefore_07days,
	// チェックイン1日前
	atCheckInBefore_01days,
	onSetAtCheckInBefore_01daysForText,
	handleClickedSendTestEmailReservationAtCheckInBefore_01days,
	// チェックイン当日
	atCheckInBefore_00days,
	onSetAtCheckInBefore_00daysForText,
	handleClickedSendTestEmailReservationAtCheckInBefore_00days,
	hotelEmailAddress,
	basicCustomMailSetting,
	defaultPlanCustomMailSetting,
	lang,

	title: _title,
	guide: _guide,
}: Props) => {
	return (
		<FeatureIslandCategoryQuestionForMain
			required={false}
			title=""
			guide=""
			isEdited={isEdited}
			hasError={hasError}
			inputChildren={
				<div className="space-y-6">
					<QuestionEmailTemplateItem
						lang={lang}
						label={"1週間前"}
						textValue={atCheckInBefore_07days?.text.value}
						textErrorMessage={atCheckInBefore_07days?.text.error}
						handleChangeText={onSetAtCheckInBefore_07daysForText}
						sendTestEmail={handleClickedSendTestEmailReservationAtCheckInBefore_07days}
						hotelEmailAddress={hotelEmailAddress}
						isOverride={defaultPlanCustomMailSetting?.atCheckInBefore_07days?.override ?? false}
						basicCustomMailSetting={basicCustomMailSetting?.atCheckInBefore_07days}
					/>
					<QuestionEmailTemplateItem
						lang={lang}
						label={"前日"}
						textValue={atCheckInBefore_01days?.text.value}
						textErrorMessage={atCheckInBefore_01days?.text.error}
						handleChangeText={onSetAtCheckInBefore_01daysForText}
						sendTestEmail={handleClickedSendTestEmailReservationAtCheckInBefore_01days}
						hotelEmailAddress={hotelEmailAddress}
						isOverride={defaultPlanCustomMailSetting?.atCheckInBefore_01days?.override ?? false}
						basicCustomMailSetting={basicCustomMailSetting?.atCheckInBefore_01days}
					/>
					<QuestionEmailTemplateItem
						lang={lang}
						label={"当日"}
						textValue={atCheckInBefore_00days?.text.value}
						textErrorMessage={atCheckInBefore_00days?.text.error}
						handleChangeText={onSetAtCheckInBefore_00daysForText}
						sendTestEmail={handleClickedSendTestEmailReservationAtCheckInBefore_00days}
						hotelEmailAddress={hotelEmailAddress}
						isOverride={defaultPlanCustomMailSetting?.atCheckInBefore_00days?.override ?? false}
						basicCustomMailSetting={basicCustomMailSetting?.atCheckInBefore_00days}
					/>
				</div>
			}
		/>
	);
};

ForCheckInEmailTemplates.displayName = "ForCheckInEmailTemplates";
